// React imports
import { useEffect, useState } from 'react';

// Components
import ModalContent from '../components/ModalContent.tsx';
import ScrollToTop from '../components/ScrollToTop.tsx';

// Contextes
import { useInTheGame } from '../utils/InTheGameContexte.tsx';
import Container from '../components/Container.tsx';

// Data
import { accessibiliteData } from '../data/accessibilite.ts';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const Accessibilite: React.FC = () => {
    // Toggle Game pour afficher le logo
    const { toggleGame } = useInTheGame();
    useEffect(() => {
        toggleGame(true);
    }, [toggleGame]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [linkHref, setLinkHref] = useState('');

    // Fonction pour gérer la confirmation avant de quitter la page
    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        // Empêcher la navigation par défaut
        e.preventDefault();
        setLinkHref(e.currentTarget.href);
        setIsModalOpen(true);
    };
    return (
        <>
            <ModalContent
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                linkHref={linkHref}
            />
            <Container color='white'>
                <section
                    id='mentionsLegalesTitles'
                    className='accessibilite-section'
                >
                    <h1 className='text-special text-special--red'>
                        Déclaration d&#39;accessibilité
                    </h1>
                    {accessibiliteData.map((mention, index) => (
                        <article
                            key={`{${index}--article}`}
                            className='mentionsLegales'
                        >
                            <h2
                                className={`text-special text-special--blue mentionsLegales__subtitle`}
                            >
                                {mention.title}
                            </h2>
                            <ReactMarkdown
                                rehypePlugins={[rehypeRaw]}
                                components={{
                                    ul: ({ ...props }) => (
                                        <ul
                                            {...props}
                                            className='ul-markdown'
                                        />
                                    ),
                                    ol: ({ ...props }) => <ol {...props} />,
                                    li: ({ ...props }) => (
                                        <li
                                            {...props}
                                            className='li-markdown'
                                        />
                                    ),
                                    p: ({ ...props }) => <p {...props} />,
                                    a: ({ ...props }) => (
                                        <a
                                            {...props}
                                            className='custom-link mentionsLegales__link'
                                            onClick={handleLinkClick}
                                        />
                                    ),
                                }}
                            >
                                {mention.content}
                            </ReactMarkdown>
                        </article>
                    ))}
                    <ScrollToTop sectionId='mentionsLegalesTitles' />
                </section>
            </Container>
        </>
    );
};

export default Accessibilite;
